<template>
  <CoreButton
    class="tw-text-core-primary-99"
    :label="t('common.messages.logout')"
    buttonType="secondary"
    iconName="Logout"
    dataTest="logout-button"
    @click="logout" />
</template>

<script setup lang="ts">
import CoreButton from 'frontcore/components/CoreButton.vue'
import i18n from 'frontcore/i18n'
import useLogout from 'frontcore/domain/authorization/model/useLogout'
import { LoginTypeOptions } from 'frontcore/domain/authorization/model/types'
import { useRoute } from 'vue-router'
import { watch } from 'vue'

interface Props {
  userLoginType: LoginTypeOptions
}
const props = defineProps<Props>()

type LogoutEmit = (e: 'logoutSuccess') => void
const emit = defineEmits<LogoutEmit>()
const route = useRoute()

const { t } = i18n.global

const {
  logout,
  continueLogoutProcess,
} = useLogout(props.userLoginType, emit)

watch(
  () => route.query.request_id,
  (newValue) => {
    if (newValue && route.query.logout === 'true') {
      continueLogoutProcess(Boolean(newValue))
    }
  }, { immediate: true }
)

</script>
